import { Component, Input, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';

import { SINGLE_DTMF_CODE_REGEX, toggleError } from 'rev-shared/util/directives/form/validation/validationUtil';
import { WebcastService } from 'rev-portal/scheduledEvents/webcast/Webcast.Service';

import styles from './VbWebcastDtmfSidebar.module.less';

@Component({
	selector: 'vb-webcast-dtmf-sidebar',
	templateUrl: './VbWebcastDtmfSidebar.Component.html',
	standalone: false
})
export class VbWebcastDtmfSidebarComponent {
	@Input() public codesToReject: string;
	@Input() public webcastId: string;

	@ViewChild('dtmfCodeControl') public dtmfCodeControl: NgModel;

	public dtmfCode: string;
	public previousCodes: string[] = [];

	public readonly SINGLE_DTMF_CODE_REGEX = SINGLE_DTMF_CODE_REGEX;
	public readonly styles = styles;

	constructor(
		private readonly WebcastService: WebcastService
	) {}

	public onSubmit(): void {
		this.WebcastService.sendVcCallControl(this.webcastId, this.dtmfCode)
			.then(() => {
				if (this.previousCodes.unshift(this.dtmfCode) > 10) {
					this.previousCodes.pop();
				}
				this.dtmfCode = '';
			});
	}

	public onChange(): void {
		toggleError(this.dtmfCodeControl?.control, 'codeToReject', this.codesToReject?.split(' ').includes(this.dtmfCode));
	}
}
